import { DotsVerticalIcon } from "@heroicons/react/solid";

import { DropdownMenu, Action } from "../DropdownMenu";

export const TableActions = <DataType,>({
  actions,
  item,
}: {
  actions?: Action<DataType>[];
  item: DataType;
}) => {
  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DropdownMenu<DataType>
        menuItems={actions}
        item={item}
        triggerClassName="!bg-transparent"
        icon={<DotsVerticalIcon className="h-5 w-5 text-gray-500" />}
      />
    </div>
  );
};
